import { render, staticRenderFns } from "./CFormColumns.vue?vue&type=template&id=72ff60de&scoped=true&"
import script from "./CFormColumns.vue?vue&type=script&lang=js&"
export * from "./CFormColumns.vue?vue&type=script&lang=js&"
import style0 from "./CFormColumns.vue?vue&type=style&index=0&id=72ff60de&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72ff60de",
  null
  
)

export default component.exports